import { graphql } from "@opensea/graphql"

export const readSwapImpactFragment = graphql(`
  fragment readSwapImpact on SwapRouteResult {
    __typename
    ... on SwapRoute {
      swapImpact {
        percent
        usd
      }
    }
  }
`)
